import { render, staticRenderFns } from "./CardSearchProduct.vue?vue&type=template&id=1d17d0de&scoped=true"
import script from "./CardSearchProduct.vue?vue&type=script&lang=js"
export * from "./CardSearchProduct.vue?vue&type=script&lang=js"
import style0 from "./CardSearchProduct.vue?vue&type=style&index=0&id=1d17d0de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d17d0de",
  null
  
)

export default component.exports